<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <el-form-item label="微信内容">
      <el-input type="textarea" v-model="ruleForm.SettingContent" style="width:79rem;"></el-input>
    </el-form-item>
    <el-form-item label="选择接收微信人员" style="margin-top: 2.2rem;">
      <div class="bgcolor" style="display:inline-block;width:79rem;height:37.3rem;">
        <UserTabControl ref="userTabls" :InputUsersids="InputUsersids"></UserTabControl>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import MyApis from "../../../apis";
import UserTabControl from "./UserTabControl";
//import utils from "../../../../../../utils";
export default {
  name: "ZjComponentWeChatDetail",
  controller: "UI",
  action: "ComponentWeChatDetail",
  components: {
    UserTabControl
  },
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String
  },
  data() {
    return {
      ruleForm: {
        SettingTitle: "微信配置",
        SettingContent: "",
        SettingId:""
        //TaskReceiverDTO: [] //任务接受对象(人员、LED屏、广播、资源等)
      },
      InputUsersids:[]
    };
  },
  created: function() {
    this.search();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    search() {
      let PlanTaskId = this.$props.PlanTaskId;
      //let TaskSubTypeId=this.$props.TaskSubTypeId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          TaskSubTypeId:'EmergencyTaskType.Communication.WeChat'
        };
        this.showLoading('加载中...');
        new MyApis.PlantasksettingApi()
          .FindByConditions(searchInfo)
          .then(r => {
            var data = r.data.Data;
            if (data.length>0) {
              this.ruleForm = data[0];
              this.Gettaskreceiverbysetting();
            }
            this.hideLoading();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    Gettaskreceiverbysetting(){
      //console.log('abd:' + this.ruleForm.SettingId + ", " + this.TaskSubTypeId);
      this.showLoading('加载中...');
      new MyApis.PlantaskreceiverApi()
        .FindByConditions({
          TaskSubTypeId: this.TaskSubTypeId,
          TaskSettinId: this.ruleForm.SettingId
        })
        .then(r => {
          var data = r.data.Data;
          //console.log(data);
          if (data) {
            this.InputUsersids = data;
          }
          this.hideLoading();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.hideLoading();
        });
    },
    Gettaskreceiver() {
      var chil = this.$refs["userTabls"];
      var userids = chil.GetOrgUserIds();
      //  var content = this.ruleForm.SettingContent;
      var receivers = [];
      var tasksett = {};

      tasksett.OrgId = this.user.Departments[0].OrgId;
      //tasksett.SettingId = utils.uuid();
      tasksett.PlanTaskId = this.PlanTaskId;
      tasksett.SettingContent = this.ruleForm.SettingContent;
      tasksett.TaskSubTypeId = this.TaskSubTypeId;
      for (var i = 0; i < userids.length; i++) {
        var receobj = {};
        receobj.OrgId = this.user.Departments[0].OrgId;
        receobj.TaskSettinId = tasksett.SettingId;
        receobj.TaskSubTypeId = this.TaskSubTypeId;
        receobj.ReceiverId = userids[i];
        receivers.push(receobj);
      }

      return { TaskSettingDTO: tasksett, TaskReceiverDTO: receivers };
    }
  }
};
</script>